import apiClient from './apiClient';

export interface UserListItem {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  telegramChatId?: string | null;
  telegramLinkedAt?: string | null;
  role: string;
  // Set on the response of createUser when the worker was auto-placed on
  // matching-type teams. Not present on list responses.
  assignedTeamIds?: string[];
}

export interface CreateUserPayload {
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role: string;
  password: string;
}

export interface UpdateUserPayload {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  telegramChatId?: string | null;
}

type ApiEnvelope<T> = { success?: boolean; data?: T };

const unwrap = <T>(response: any): T => {
  const body = response?.data ?? response;
  const envelope = body as ApiEnvelope<T>;
  return envelope && Object.prototype.hasOwnProperty.call(envelope, 'data')
    ? (envelope.data as T)
    : (body as T);
};

class UserService {
  async searchUsers(params: { search?: string; role?: string; limit?: number } = {}): Promise<UserListItem[]> {
    const searchParams = new URLSearchParams();
    if (params.search) searchParams.set('search', params.search);
    if (params.role) searchParams.set('role', params.role);
    if (params.limit) searchParams.set('limit', String(params.limit));
    const qs = searchParams.toString();
    const response = await apiClient.get<ApiEnvelope<UserListItem[]>>(`/users${qs ? `?${qs}` : ''}`);
    return unwrap<UserListItem[]>(response) || [];
  }

  async createUser(payload: CreateUserPayload): Promise<UserListItem> {
    const response = await apiClient.post<ApiEnvelope<UserListItem>>('/users', payload);
    return unwrap<UserListItem>(response);
  }

  async updateUser(id: string, payload: UpdateUserPayload): Promise<UserListItem> {
    const response = await apiClient.patch<ApiEnvelope<UserListItem>>(`/users/${id}`, payload);
    return unwrap<UserListItem>(response);
  }
}

export default new UserService();
